/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

import { FaBlogger, FaCoffee, FaInstagram, FaLinkedin, FaPatreon, FaPaypal, FaYoutube } from 'react-icons/fa';

function DemoFooter() {
  return (
    <footer className="section section-dark gradient-background-osc page-footer font-small indigo">

      <Container>

        <Row className="text-center d-flex justify-content-center pt-5 mb-3">

          <Col md="2" className="mb-3">
            <h6>
              <a href="/mkdote/#/development" style={{ color: '#FFFFFFB3' }} > Development </a>
            </h6>
          </Col>

          <Col md="2" className="mb-3">
            <h6>
              <a href="/mkdote/#/about" style={{ color: '#FFFFFFB3' }} >About</a>
            </h6>
          </Col>

          <Col md="2" className="mb-3">
            <h6>
              <a href="/mkdote/#/credits" style={{ color: '#FFFFFFB3' }} >Credits</a>
            </h6>
          </Col>

          <Col md="2" className="mb-3">
            <h6>
              <a href="/mkdote/#/specialty" style={{ color: '#FFFFFFB3' }} >Special thanks</a>
            </h6>
          </Col>

        </Row >

        <hr className="rgba-white-light" style={{ margin: '0 15%' }} />

        <Row className="d-flex text-center justify-content-center mb-md-0 mb-4">

          <Col md="8" className=" col-12 mt-5">
            <p style={{ lineHeight: '1.7rem' }} >
              MKDOTE is just a totally free non-profit fan-game made by fans for fans.
            </p>
            <p style={{ lineHeight: '1.7rem' }} >
              WB GAMES LOGO, WBIE LOGO, WB SHIELD, NETHERREALM STUDIOS LOGO, MORTAL KOMBAT, THE DRAGON LOGO,
              and all related characters and elements are trademarks of and © Warner Bros. Entertainment Inc. (s20)
            </p>
            <br />
          </Col>

        </Row >
        <hr className="clearfix d-md-none rgba-white-light" style={{ margin: '10% 15% 5%' }} />

        <Row className="pb-3">

          <Col md="4" />

          <Col md="4">

            <Row className="text-center">

              <Col xs="2">
                <a href="https://www.youtube.com/channel/UCmlmsLb9LyH3K9axEmq0MNA" target="_blank" rel="noopener noreferrer" > <FaYoutube size="20px" /> </a>
              </Col>
              <Col xs="2">
                <a href="https://www.linkedin.com/in/danilo-abell%C3%A1-b98535142/" target="_blank" rel="noopener noreferrer" > <FaLinkedin size="20px" /> </a>
              </Col>
              <Col xs="2">
                <a href="https://www.instagram.com/daniloabella24/" target="_blank" rel="noopener noreferrer" >  <FaInstagram size="20px" /> </a>
              </Col>
              <Col xs="2">
                <a href="https://mkdefenderearth.blogspot.com/" target="_blank" rel="noopener noreferrer" > <FaBlogger size="20px" /> </a>
              </Col>
              <Col xs="2">
                <a href="https://www.patreon.com/daniloabella" target="_blank" rel="noopener noreferrer" > <FaPatreon size="20px" /> </a>
              </Col>
              <Col xs="2">
                <a href="https://www.paypal.com/donate?hosted_button_id=2GRV5G6UELHPL" target="_blank" rel="noopener noreferrer" > <FaPaypal size="20px" /> </a>
              </Col>

            </Row>

          </Col>

          <Col md="4" />

        </Row >

      </Container>

    </footer>
  );
}

export default DemoFooter;
